import axios from '@lib/axios';

export class API {
  public static uploadImage = async (file: File) => {

    const { data: { asset }} = await axios.post('/assets/upload', { file }, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return asset.url;
  }
}

export default API
